import { render, staticRenderFns } from "./Employers.vue?vue&type=template&id=a9ee7f44&scoped=true"
import script from "./Employers.vue?vue&type=script&lang=js"
export * from "./Employers.vue?vue&type=script&lang=js"
import style0 from "./Employers.vue?vue&type=style&index=0&id=a9ee7f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ee7f44",
  null
  
)

export default component.exports